import React from "react";

import Logo from "../../assets/images/scf-g-en.png"

// components
import { LoginPage } from "./LoginPage/LoginPage";
import useLogin from "./useLogin";
import { OtpPage } from "./OtpPage/OtpPage";

export const Login = () => {

  const { phoneNumber, setPhoneNumber, otp, setOtp, getCaptchaImage, captchaImg, setCaptcha, captcha, login, loginOtp, otpCode, setOtpCode } = useLogin()

  return (
    <div className="login-page secondary-full-screen">
      <div className="login-page-logo">
        <img src={Logo} alt="" />
      </div>

      {!otp ?
        <>
          <p className="font-size-header -mt-40">پنل سازمانی</p>
          <LoginPage phoneNumber={phoneNumber} setPhoneNumber={setPhoneNumber} getCaptchaImage={getCaptchaImage} captchaImg={captchaImg} setCaptcha={setCaptcha} captcha={captcha} login={login} />
        </>
        :
        <>
          <p className="-mt-40" style={{ fontSize: "20px" }}>کد تایید به شماره <span style={{ fontSize: "20px", color: "#06DF70" }}>{phoneNumber}</span> ارسال شده.</p>
          <OtpPage otp={otp} phoneNumber={phoneNumber} setPhoneNumber={setPhoneNumber} otpCode={otpCode} setOtpCode={setOtpCode} loginOtp={loginOtp} setOtp={setOtp} getCaptchaImage={getCaptchaImage} />
        </>
      }
    </div>
  );
};
